
namespace RioERP.Users {

    @Serenity.Decorators.registerClass()
    export class BrandAmbassadorDialog extends Serenity.EntityDialog<BrandAmbassadorRow, any> {
        protected getFormKey() { return BrandAmbassadorForm.formKey; }
        protected getIdProperty() { return BrandAmbassadorRow.idProperty; }
        protected getLocalTextPrefix() { return BrandAmbassadorRow.localTextPrefix; }
        protected getNameProperty() { return BrandAmbassadorRow.nameProperty; }
        protected getService() { return BrandAmbassadorService.baseUrl; }
        protected getDeletePermission() { return BrandAmbassadorRow.deletePermission; }
        protected getInsertPermission() { return BrandAmbassadorRow.insertPermission; }
        protected getUpdatePermission() { return BrandAmbassadorRow.updatePermission; }

        protected form = new BrandAmbassadorForm(this.idPrefix);

    }
}